module.exports = __webpack_public_path__ + "static/media/BrightBee_Platform-Screens-2.d961efb1.png";